import React, { useCallback } from 'react';
import { format, zonedTimeToUtc } from 'date-fns-tz';
import { useDateTimeInput } from '../..';
import { DateTimePicker } from '../../../DateTimePicker';
import { Container } from './styled';

export const DateTimeCalendarInput: React.FC = () => {
  const {
    isActive,
    close,
    setInput,
    onChange,
    inputDate,
    timeZone,
    minDate,
    maxDate,
    hideTime,
    hideDate,
    use12HourMode,
    containerRef,
    calendarAlignment,
    dateTimeFormat,
    t,
  } = useDateTimeInput();

  const handleSubmit = useCallback(
    (date: Date) => {
      if (hideTime) {
        date.setHours(0);
        date.setMinutes(0);
      }
      const utcDate = timeZone ? zonedTimeToUtc(date, timeZone) : date;
      setInput(format(date, dateTimeFormat));
      onChange(utcDate);
      close();
    },
    [setInput, onChange, dateTimeFormat, close, hideTime, timeZone],
  );

  if (!isActive) return null;

  return (
    <Container
      align={
        calendarAlignment ||
        ((containerRef?.current?.getBoundingClientRect().top || 0) < 600
          ? 'bottom'
          : 'top')
      }
    >
      <DateTimePicker
        onSubmit={handleSubmit}
        onCancel={close}
        value={inputDate}
        minDate={minDate}
        maxDate={maxDate}
        hideTime={hideTime}
        hideDate={hideDate}
        use12HourMode={use12HourMode}
        t={t}
      />
    </Container>
  );
};
